document.addEventListener("DOMContentLoaded", function() {
    var btnBurger = document.querySelector('#mobile-toggle');
    var mainMenu = document.querySelector('.navigation-main');

    btnBurger.addEventListener('click', function() {
        mainMenu.classList.toggle('open');
    });

    window.addEventListener('resize', function() {
        if (window.innerWidth > 767) {
            mainMenu.classList.remove('open');
        }
    });
});